import React from "react";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";

interface FilePreviewProps {
  fileUrl: string;
  fileType: string;
  fileName: string;
  isMobile?: boolean;
}

const FilePreview: React.FC<FilePreviewProps> = ({ fileUrl, fileType, fileName, isMobile }) => {
  const isPdf: boolean = fileType?.toLowerCase().includes("pdf") || fileType?.toLowerCase() === "application/pdf";

  return (
    <div className="p-4">
      {isPdf ? (
        <div className="rounded-lg overflow-hidden shadow-lg">
          {isMobile ? (
            <div className="flex flex-col items-center justify-center py-8">
              <button
                onClick={() => window.open(fileUrl, "_blank")}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg shadow hover:bg-blue-700 transition"
              >
                Visualizar PDF
              </button>
              <span className="mt-4 text-gray-500 text-center text-sm">Clique para abrir o PDF em uma nova aba</span>
            </div>
          ) : (
            <Zoom>
              <iframe
                src={fileUrl}
                className="w-full h-[40vh] sm:h-[60vh] md:h-[75vh] lg:h-[80vh]"
                title="PDF Viewer"
                loading="lazy"
                // sandbox="allow-scripts allow-same-origin"
                allow="fullscreen"
                style={{
                  border: "none",
                  backgroundColor: "transparent",
                }}
              />
            </Zoom>
          )}
        </div>
      ) : (
        <div className="flex justify-center">
          <Zoom>
            <img
              src={fileUrl}
              alt={fileName}
              className="object-contain w-full max-h-[40vh] sm:max-h-[50vh]"
              loading="lazy"
              crossOrigin="anonymous"
            />
          </Zoom>
        </div>
      )}
      <div className="flex w-full justify-center mt-2">
        <span className="text-sm sm:text-base md:text-xl font-bold break-words text-center">{fileName}</span>
      </div>
    </div>
  );
};

export default FilePreview;
